
import { Base } from '../base-component';
import './share-icons-horizontal.component.scss';

export class ShareIconsHorizontal extends Base {

	shareButton: Element;
	shareLinks: Element[];

	emailButton: Element;
	facebookButton: Element;
	twitterButton: Element;
	linkedinButton: Element;
	whatsButton: Element;

	shareUrl: string;
	shareTitle: string;
	shareDescription: string;
	shareImage: string;

	emailLink: string;
	facebookLink: string;
	twitterLink: string;
	linkedinLink: string;
	whatsApp: string;

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.shareButton = this.element.querySelector('.js-share');
		this.shareLinks = Array.from(this.element.querySelectorAll('.share-icons-horizontal__link'));

		this.emailButton = this.element.querySelector('.js-share-mail');
		this.facebookButton = this.element.querySelector('.js-share-facebook');
		this.twitterButton = this.element.querySelector('.js-share-twitter');
		this.linkedinButton = this.element.querySelector('.js-share-linkedin');		
		this.whatsButton = this.element.querySelector('.js-share-whatsapp');

		this.shareUrl = encodeURIComponent(document.URL);
		this.shareTitle = '';
		this.shareDescription = '';
		this.shareImage = '';

		this.setShareLinks();


	}

	bindEvents() {
		document.addEventListener('click', () => this.closeShareOnDocumentClick(event));
		this.shareButton.addEventListener('click', () => this.toggleShare());

		if(this.facebookButton){
			this.facebookButton.addEventListener('click', (event)=>{
	
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
	
				let data = element.getAttribute('data-social');
				this.newPopup(data, 'Standard Bank')
	
			})
		}

		if(this.twitterButton){
			this.twitterButton.addEventListener('click', (event)=>{
				
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
	
				let data = element.getAttribute('data-social');
				this.newPopup(data, 'Standard Bank')
	
			})
		}

		if(this.linkedinButton){
			this.linkedinButton.addEventListener('click', (event)=>{
				
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
	
				let data = element.getAttribute('data-social');
				this.newPopup(data, 'Standard Bank')
	
			})
		}

		if(this.whatsButton){
			this.whatsButton.addEventListener('click', (event)=>{
				
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
	
				let data = element.getAttribute('data-social');
				this.newPopup(data, 'Standard Bank')
	
			})
		}
		window.addEventListener('resize', (event)=>{

			let windowWidth = window.screen.width;
			if(windowWidth > 767) {
				this.whatsButton.setAttribute(
					'data-social',
					`https://web.whatsapp.com/send?text=${this.shareDescription}&url=${this.shareUrl}`
				);
			}else{
				this.whatsButton.setAttribute(
					'data-social',
					`whatsapp://send?text=${this.shareDescription}&url=${this.shareUrl}`
				);
			}

		})
		
	}

	getShareMeta(meta) {

		let ogAttribute = document.querySelector(`meta[property='og:${meta}']`);

		if (ogAttribute) {
			return encodeURIComponent(ogAttribute.getAttribute('content'));
		}

		return '';

	}

	setShareMeta() {
		this.shareTitle = this.getShareMeta('title');
		this.shareDescription = this.getShareMeta('description');
		this.shareImage = this.getShareMeta('image');
	}

	setShareLinks() {

		this.setShareMeta();

		setTimeout(() => {

			this.emailButton.setAttribute(
				'href',
				`mailto:?subject=${this.shareTitle}&body=${this.shareDescription} - ${this.shareUrl}`
			);

			this.facebookButton.setAttribute(
				'data-social',
				`https://www.facebook.com/dialog/share?app_id=363419304366429&display=popup&href=${this.shareUrl}&redirect_uri=${this.shareUrl}`
			);

			this.twitterButton.setAttribute(
				'data-social',
				`https://twitter.com/intent/tweet?url=${this.shareUrl}&text=${this.shareDescription}`
			);

			this.linkedinButton.setAttribute(
				'data-social',
				`https://www.linkedin.com/shareArticle?mini=true&url=${this.shareUrl}`
			);

			let windowWidth = window.screen.width;
			if(windowWidth > 767) {
				this.whatsButton.setAttribute(
					'data-social',
					`https://web.whatsapp.com/send?text=${this.shareDescription}&url=${this.shareUrl}`
				);
			}else{
				this.whatsButton.setAttribute(
					'data-social',
					`whatsapp://send?text=${this.shareDescription}&url=${this.shareUrl}`
				);
			}

		}, 200);

	}

	toggleShare() {

		if (this.emailButton.classList.contains('share-icons-horizontal__link--open')) {

			this.closeShare();

		} else {

			this.openShare();

		}

	}

	toggleIcons(action) {

		let shareIconClosed = this.element.querySelector('.js-share-closed');
		let shareIconOpened = this.element.querySelector('.js-share-opened');
		let shareIconLinks = this.element.querySelector('.share-icons-horizontal__links');

		if (action === 'open') {

			shareIconLinks.classList.add('share-icons-horizontal__links--opened');
			shareIconClosed.classList.add('share__button-icon--hidden');
			shareIconOpened.classList.remove('share__button-icon--hidden');


		} else {

			shareIconLinks.classList.remove('share-icons-horizontal__links--opened');
			shareIconOpened.classList.add('share__button-icon--hidden');
			shareIconClosed.classList.remove('share__button-icon--hidden');

		}

	}

	closeShareOnDocumentClick(event) {

		let targetElement = event.target;

		do {

			if (targetElement === this.element) {
				return;
			}

			targetElement = targetElement.parentNode;

		} while (targetElement);

		this.closeShare();

	}

	openShare() {

		this.toggleIcons('open');

		let timeoutDelay = 0;

		this.shareLinks.forEach(function (shareLink) {

			setTimeout(() => {
				shareLink.classList.add('share-icons-horizontal__link--open');
			}, timeoutDelay);

			timeoutDelay += 50;

		});

	}

	closeShare() {

		this.toggleIcons('close');

		let timeoutDelay = 0;
		let shareLinksClone = this.shareLinks.slice().reverse();

		shareLinksClone.forEach(function (shareLink) {

			setTimeout(() => {
				shareLink.classList.remove('share-icons-horizontal__link--open');
			}, timeoutDelay);

			timeoutDelay += 100;

		});

	}

	newPopup(url, windowName) {

		window.open(url,windowName,'height=500,width=500,left=10,top=10,titlebar=no,toolbar=no,menubar=no,location=no,directories=no,status=no');

	}

}



// WEBPACK FOOTER //
// ./components/share-icons-horizontal/share-icons-horizontal.component.ts